// Vade ve risk. Sunucu kuralı (AccountManager.CheckRiskLimitAsync): boş = sınırsız, 0 = borçlanma yok.
import React from 'react';
import {
  Checkbox, FormControl, FormControlLabel, Grid, InputAdornment, MenuItem, Select, TextField, Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RISK_ACTION_ALLOW, RISK_ACTION_BLOCK, type AccountCardForm } from '../useAccountCardForm';
import { L, SectionTitle } from './fields';

export const RiskSection: React.FC<{ f: AccountCardForm }> = ({ f }) => {
  const { t } = useTranslation('accounting');
  const d = f.accountData;
  return (
    <>
      <SectionTitle title={t(`${L}.layout.sections.risk`, 'Vade ve risk')} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth size="small" type="number" label={t(`${L}.fields.paymentDueDays`)}
            value={d.paymentDueDays} onChange={(e) => f.handleChange('paymentDueDays', e.target.value)}
            inputProps={{ min: 0, step: 1 }}
            InputProps={{ endAdornment: <InputAdornment position="end">{t(`${L}.layout.days`, 'gün')}</InputAdornment> }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="account-card-risk"
            fullWidth size="small" type="number" label={t(`${L}.layout.riskLimit`, 'Risk limiti')}
            value={d.riskLimitAmount} onChange={(e) => f.handleChange('riskLimitAmount', e.target.value)}
            inputProps={{ min: 0, step: '0.01' }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <FormControl variant="standard" sx={{ minWidth: 56 }}>
                    <Select
                      value={d.riskLimitCurrency}
                      onChange={(e) => f.handleChange('riskLimitCurrency', String(e.target.value))}
                      inputProps={{ 'aria-label': t(`${L}.fields.currency`) }}
                    >
                      {f.availableCurrencies.filter(c => c.active).map(c => (
                        <MenuItem key={c.code} value={c.code}>{f.getCurrencySymbol(c.code)}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            select fullWidth size="small" label={t(`${L}.layout.onExceedLong`, 'Limit aşılınca')}
            value={d.riskLimitAction} onChange={(e) => f.handleChange('riskLimitAction', e.target.value)}
          >
            <MenuItem value={RISK_ACTION_ALLOW}>{t(`${L}.layout.riskAllow`, 'Uyar, işleme izin ver')}</MenuItem>
            <MenuItem value={RISK_ACTION_BLOCK}>{t(`${L}.layout.riskBlock`, 'Satışı engelle')}</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={
              <Checkbox
                checked={d.preventNegativeBalance}
                onChange={(e) => f.handleChange('preventNegativeBalance', e.target.checked)}
              />
            }
            label={t(`${L}.layout.preventNegative`, 'Eksi bakiyeye izin verme')}
          />
        </Grid>
      </Grid>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        {t(`${L}.layout.riskLimitHelp`, 'Limit boş = sınırsız. 0 = veresiye yok.')}
      </Typography>
    </>
  );
};
